import React, { Component } from 'react';
import history from '../../routes/history';
import Loader from '../../components/Loader';
import GoogleLogin from 'react-google-login';
import Cookies from 'universal-cookie';
import AccountApiClient from "../../stores/AccountApiClient";

import './SignInPage.css';

export default class SignInPage extends Component {

  constructor(props){
    super(props);
    window.page = this;
  }

  onRequest = (e) =>
  {
    window.page.loader.show();
  }

  onSuccess = (e) =>
  {
    window.page.loader.hide();
    new AccountApiClient().signIn(e.accessToken).then(function () {
      var cookies = new Cookies();
      cookies.set('AuthenticationToken', e.accessToken, { path: '/' });
      history.push('/Analytics/Alerts');
    });
  }

  onError = (e) =>
  {
    window.page.loader.hide();
  }

  render() {
    return (
      <div className="sign-in-page">
        <Loader />
        <div className="container">
        <h2>MeSeems Performance Monitor</h2>
        <hr/>
        <GoogleLogin
          clientId="618373152922-c8ahhdacju7pkhak2lkijpr3vg184pd7.apps.googleusercontent.com"
          buttonText="Sign In"
          onRequest={this.onRequest}
          onSuccess={this.onSuccess}
          onFailure={this.onError}
          style={{}}
        />
        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/routes/account/SignInPage.js